/**
 * Cor e iniciais do avatar quando não há foto. A cor é derivada do nome (matiz estável
 * por hash), em tons pastel: o mesmo nome tem sempre a mesma cor, em qualquer tela.
 */

function hue(name: string): number {
  let h = 7;

  for (const char of name) {
    h = (Math.imul(h, 31) + char.charCodeAt(0)) >>> 0;
  }

  return h % 360;
}

export function avatarColors(name: string): { bg: string; fg: string } {
  const h = hue(name);

  return { bg: `oklch(0.92 0.045 ${h})`, fg: `oklch(0.4 0.1 ${h})` };
}

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? '?';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';

  return (first + last).toUpperCase();
}
